import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/browser-live')({
  component: Outlet,
});
